import axiosClient from './axiosClient';

export default {
  // Costruisce URL OAuth per autorizzare l'utente
  buildAuthorizationUrl: (userId) =>
    axiosClient.get(`/google-calendar/authorize?userId=${userId}`),

  // Scambia il codice OAuth con access + refresh token
  exchangeCode: (userId, code) =>
    axiosClient.post(`/google-calendar/exchange?userId=${userId}&code=${code}`),

  // Revoca i token Google per l'utente
  revokeTokens: (userId) =>
    axiosClient.post(`/google-calendar/revoke?userId=${userId}`),

  // Crea un evento sul calendario dell'utente
  createEvent: (userId, data) =>
    axiosClient.post(`/google-calendar/event/${userId}`, data),
};
